query DocumentPoolFiles(
  $orderBy: [DocumentPoolsOrderBy!]
  $filter: DocumentPoolFilter
) {
  documentPools(orderBy: $orderBy, filter: $filter) {
    nodes {
      id
      _rowTimestamp
      name
      description
      isBusinessUnitSelector
      isCompanySelector
      isCreateCopyWithSelection
      isDepartmentSelector
      parentDocumentPoolId
      _isUpdatable
      _isDeletable
      isDocumentTypeSelector
      extractionTypeId
       userGroupId
      defaultDepartmentId
      defaultBusinessUnitId
      isEntityTypeSelector
      isPrivatePool
      defaultDocumentTypes {
        id
        documentType
        extractionTypes {
          nodes {
            id
            extractionType
          }
        }
      }
      defaultDocumentTypeId
      _documentFileCount {
        availableDocuments
        selectedDocuments
      }
      _subfolderDocumentFileCount{
        availableDocuments
        selectedDocuments
      }
      # entityDocumentsByDocumentPoolIdAndEntityTypeId {
      #   totalCount
      # }
    }
  }
}
